module.exports = __webpack_public_path__ + "img/ID_VK_Icon.eff003c9.svg";